import { memo, PropsWithChildren, useEffect, useRef, useState } from "react";
import "./WithSideAds.scss";
import { useExperiment } from "@/common/hooks/useExperiment";
import useWindowDimensions from "@/common/hooks/useWindowDimension";
import { EXPERIMENT_NO_ADS } from "@/common/services/experiment/constants";
import { OnlyFansCreatorsSidebar } from "./OnlyFansCreatorsSidebar";

const ADS_WIDTH = 466;

type WithSideAdsProps = PropsWithChildren;

export const WithSideAds = memo((props: WithSideAdsProps) => {
  const { children } = props;
  const { variant: noAds } = useExperiment({ key: EXPERIMENT_NO_ADS, fallback: false });
  const isDesktop = useWindowDimensions();

  const [showAds, setShowAds] = useState<boolean>(isDesktop);

  const contentRef = useRef<HTMLDivElement | null>(null);

  const ref = useRef<HTMLDivElement | null>(null);
  const width = ref.current?.clientWidth ?? 0;

  useEffect(() => {
    if (width === 0) {
      return;
    }

    const contentWidth = contentRef.current?.clientWidth ?? 0;

    const maxWidth = contentWidth + ADS_WIDTH;
    setShowAds(width >= maxWidth);
  }, [width]);

  return (
    <div className="skyWrapper" ref={ref}>
      {!noAds && showAds && <div className="left side"></div>}

      <div className="middle" ref={contentRef}>
        {children}
      </div>

      {!noAds && showAds && <div className="right side">
        <OnlyFansCreatorsSidebar />
      </div>}
    </div>
  );
});
